<!-- ── NOTIFICATION MODE ── -->
<div class="phi-consent-container notification-mode" *ngIf="mode === 'notification'">
  <div class="notification-header">
    <mat-icon class="notification-icon">info</mat-icon>
    <h2 class="notification-title">Notice</h2>
  </div>
  <div class="notification-message">
    <p>{{ notificationMessage }}</p>
  </div>
  <mat-dialog-actions class="notification-actions">
    <button class="btn-ok" (click)="closeDialog()">OK</button>
  </mat-dialog-actions>
</div>

<!-- ── CONSENT MODE ── -->
<div class="phi-consent-container" *ngIf="mode === 'consent'">

  <!-- ── CONSENT CARD ── -->
  <div class="card" *ngIf="viewState === 'consent'">

    <div class="card-header">
      <div class="shield-icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 2L3 5.5V10C3 13.9 6.13 17.5 10 18.3C13.87 17.5 17 13.9 17 10V5.5L10 2Z" fill="#B5D4F4" stroke="#185FA5" stroke-width="1.4" stroke-linejoin="round"/>
          <path d="M7.5 10.2l1.9 1.9 3.1-3.6" stroke="#185FA5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="header-text">
        <h1>PHI Viewing Consent Agreement</h1>
        <p>Protected Health Information Notice</p>
      </div>
      <div class="hipaa-badge">HIPAA</div>
    </div>

    <!-- <div class="card-body" style="max-height: none; border-bottom: 1px solid rgba(0,0,0,0.10); padding: 20px 24px;">

      <div class="section-block plain" style="display: flex; flex-direction: column; gap: 14px;">

        <p class="body-text">This application displays <strong style="color:#1A1917; font-weight:600;">Protected Health Information (PHI)</strong>. By continuing, you consent to viewing sensitive health data within this application.</p>

        <div style="height: 1px; background: rgba(0,0,0,0.10);"></div>

        <div>
          <p class="body-text" style="margin-bottom: 9px;">By selecting <strong style="color:#1A1917; font-weight:600;">"I Agree"</strong> you confirm that:</p>
          <div class="consent-list">
            <div class="consent-item">
              <div class="consent-num"><span>1</span></div>
              <p class="consent-text">You are authorized to view this health information.</p>
            </div>
            <div class="consent-item">
              <div class="consent-num"><span>2</span></div>
              <p class="consent-text">You will keep it confidential and not share with unauthorized individuals.</p>
            </div>
            <div class="consent-item">
              <div class="consent-num"><span>3</span></div>
              <p class="consent-text">You understand viewing this information is at your own discretion.</p>
            </div>
          </div>
        </div>

        <div style="height: 1px; background: rgba(0,0,0,0.10);"></div>

        <p class="body-text" style="color:#7A4A08; font-size: 12.5px;">
          <svg width="11" height="11" viewBox="0 0 12 12" fill="none" style="vertical-align:-1px; margin-right:5px; flex-shrink:0;">
            <path d="M6 1L1 10.5h10L6 1z" stroke="#A05C0A" stroke-width="1.2" stroke-linejoin="round" fill="#FAC775"/>
            <line x1="6" y1="5" x2="6" y2="7.8" stroke="#A05C0A" stroke-width="1.2" stroke-linecap="round"/>
            <circle cx="6" cy="9.3" r="0.6" fill="#A05C0A"/>
          </svg>
          Use only on secure, private devices and log out after use.
        </p>

      </div>

    </div> -->

    <div class="card-footer">

      <label class="check-label" [class.checked]="consentAgreed">
        <input type="checkbox" [(ngModel)]="consentAgreed" />
        <span class="check-text">I accept responsibility for accessing Protected Health Information (PHI) only as authorized and for maintaining its confidentiality in compliance with all applicable privacy laws and policies.</span>
      </label>

      <div class="btn-row">
        <button class="btn btn-secondary" [disabled]="isSubmitting" (click)="this.dialogRef.close()">Decline</button>
        <button class="btn btn-primary" [class.active]="consentAgreed && !isSubmitting" [disabled]="!consentAgreed || isSubmitting" (click)="agree()">
          <span *ngIf="!isSubmitting">Accept</span>
          <span *ngIf="isSubmitting" class="btn-loading">Submitting...</span>
        </button>
      </div>

    </div>

    <div class="timestamp-row">
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
        <circle cx="5.5" cy="5.5" r="4.5" stroke="#AAAAAA" stroke-width="1"/>
        <path d="M5.5 3v2.5l1.5 1.5" stroke="#AAAAAA" stroke-width="1" stroke-linecap="round"/>
      </svg>
      <span class="timestamp-text">{{ currentTimestamp }}</span>
    </div>

  </div>

  <!-- ── SUCCESS STATE ── -->
  <div class="result-card" *ngIf="viewState === 'success'" [class.border-complete]="borderLoadComplete">
    <div class="result-icon-wrapper">
      <!-- Animated circular border -->
      <svg class="border-ring" width="76" height="76" viewBox="0 0 76 76">
        <circle class="border-ring-bg" cx="38" cy="38" r="34" fill="none" stroke="#AEDAAE" stroke-width="3"/>
        <circle class="border-ring-fill" cx="38" cy="38" r="34"
          fill="none" stroke="#2E6B2E" stroke-width="3"
          stroke-linecap="round"
          [style.stroke-dasharray]="'213.6'"
          [style.stroke-dashoffset]="'213.6'"
          (animationend)="onBorderAnimationComplete()"/>
      </svg>
      <!-- Tick icon centered inside -->
      <div class="result-icon success" [class.tick-visible]="true">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
          <path class="tick-path" d="M5.5 13l5.5 5.5L20.5 7.5" stroke="#2E6B2E" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
    <p class="result-title" [class.fade-in]="borderLoadComplete">Consent recorded</p>
    <p class="result-body" [class.fade-in]="borderLoadComplete">You have agreed to the PHI Viewing Consent Agreement. You may now access protected health information within this application.</p>
    <div class="result-meta" [class.fade-in]="borderLoadComplete">
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
        <circle cx="6.5" cy="6.5" r="5.5" stroke="#8A8882" stroke-width="1"/>
        <path d="M6.5 4v3l1.8 1.8" stroke="#8A8882" stroke-width="1.1" stroke-linecap="round"/>
      </svg>
      <span>Consented at {{ agreedTimestamp }}</span>
    </div>
  </div>

  <!-- ── DECLINED STATE ── -->
  <div class="result-card" *ngIf="viewState === 'declined'">
    <div class="result-icon danger">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M7 7l10 10M17 7L7 17" stroke="#8B2020" stroke-width="2.2" stroke-linecap="round"/>
      </svg>
    </div>
    <p class="result-title">Access declined</p>
    <p class="result-body">You have declined to consent to PHI viewing. Access to protected health information has been restricted.</p>
    <button class="m-1 btn-link" (click)="handleReview()">Review agreement</button>
    <button class="m-1 btn btn-secondary" (click)="this.dialogRef.close()">Cancel</button>
  </div>

</div>
